import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { validations } from "./validations";
import { useFormik } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import Image from "../assets/image 398.png";

const initialValues = {
  name: "",
  last: "",
  email: "",
  phoneNumber: "",
  message: "",
  country: "",
};

const Contact = () => {
  const form = useRef();
  const [captchaValidated, setCaptchaValidated] = useState(false);
  const [captchaError, setCaptchaError] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState(""); // Track submission status

  const onCaptchaChange = (value) => {
    if (value) {
      setCaptchaValidated(true);
      setCaptchaError("");
    } else {
      setCaptchaValidated(false);
    }
  };

  const { values, errors, touched, handleBlur, handleChange, resetForm } = useFormik({
    initialValues,
    validationSchema: validations,
    onSubmit: (values) => {
      console.log("Form values:", values);
    },
  });

  const sendEmail = (e) => {
    e.preventDefault();

    if (!captchaValidated) {
      setCaptchaError("Please complete the CAPTCHA.");
      return;
    }

    emailjs
      .sendForm(
        "service_46lnrmss", // Replace with your EmailJS service ID
        "template_0ilr829", // Replace with your EmailJS template ID
        form.current,
        "0ofxr_Kh6bIHXuglK" // Replace with your EmailJS public key
      )
      .then(
        () => {
          setSubmissionStatus("Success! Your message has been sent."); // Success feedback
          resetForm(); // Clear the form
          setCaptchaValidated(false); // Reset CAPTCHA validation
        },
        (error) => {
          console.error("FAILED...", error.text);
          setSubmissionStatus("Failed to send your message. Please try again.");
        }
      );
  };

  return (
    <div className="">
      <form ref={form} onSubmit={sendEmail}>
        <div id="contact" className="flex md:flex-row flex-col p-4 bg-[#FAEBCC] gap-10">
          <div>
            <img
              className="md:h-[720px] h-auto md:w-[800px] flex"
              src={Image}
              alt="Contact"
            />
          </div>
          <div className="flex flex-col  pt-20 justify-center items-center">
            <div className="mt-4">
              <h1 className="text-4xl font-bold text-red-800 flex font-dancing">
                <span className="px-2">Get</span> In Touch
              </h1>
            </div>
            <div className="flex flex-col gap-10 mt-10">
              {/* Name Fields */}
              <div className="flex md:flex-row flex-col gap-16">
                <div className="border-b-2 border-black">
                  <label htmlFor="name" className="outline-none pr-4 bg-[#FAEBCC]">
                    First Name <span className="text-red-500">*</span>:
                  </label>
                  <input
                    className="outline-none bg-[#FAEBCC]"
                    type="text"
                    autoComplete="off"
                    name="name"
                    id="name"
                    placeholder="Enter Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.name && touched.name && (
                    <p className="form-error text-red-500 uppercase">{errors.name}</p>
                  )}
                </div>
                <div className="border-b-2 border-black">
                  <label htmlFor="last" className="bg-[#FAEBCC] outline-none pr-4">
                    Last Name :
                  </label>
                  <input
                    className="outline-none bg-[#FAEBCC]"
                    type="text"
                    autoComplete="off"
                    name="last"
                    id="last"
                    placeholder="Enter Last Name"
                    value={values.last}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.last && touched.last && (
                    <p className="form-error text-red-500 uppercase">{errors.last}</p>
                  )}
                </div>
              </div>

              {/* Phone Number */}
              <div className="border-b-2 border-black">
                <label htmlFor="phoneNumber" className="bg-[#FAEBCC] outline-none pr-4">
                  Contact No. <span className="text-red-500">* </span>:
                </label>
                <input
                  className="outline-none bg-[#FAEBCC]"
                  type="text"
                  autoComplete="off"
                  name="phoneNumber"
                  id="phoneNumber"
                  placeholder="Enter Contact"
                  value={values.phoneNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.phoneNumber && touched.phoneNumber && (
                  <p className="form-error text-red-500 uppercase">{errors.phoneNumber}</p>
                )}
              </div>

              {/* Email */}
              <div className="border-b-2 border-black">
                <label htmlFor="email" className="bg-[#FAEBCC] outline-none pr-4">
                  Email id<span className="text-red-500">* </span>:
                </label>
                <input
                  className="outline-none bg-[#FAEBCC]"
                  type="email"
                  autoComplete="off"
                  name="email"
                  id="email"
                  placeholder="Enter Email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.email && touched.email && (
                  <p className="form-error text-red-500 uppercase">{errors.email}</p>
                )}
              </div>

              {/* Country */}
              <div className="border-b-2 border-black">
                <label htmlFor="country" className="bg-[#FAEBCC] outline-none pr-4">
                  Country :
                </label>
                <input
                  className="outline-none bg-[#FAEBCC]"
                  type="text"
                  autoComplete="off"
                  name="country"
                  id="country"
                  placeholder="Enter Country"
                  value={values.country}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>

              {/* Message */}
              <div className="border-b-2 border-black">
                <label htmlFor="message" className="bg-[#FAEBCC] outline-none pr-4">
                  Message :
                </label>
                <input
                  className="outline-none md:w-[600px] bg-[#FAEBCC]"
                  type="text"
                  autoComplete="off"
                  name="message"
                  id="message"
                  placeholder="Enter message"
                  value={values.message}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>

              {/* reCAPTCHA */}
              <div className="">
                <ReCAPTCHA
                  sitekey="6LcFkLIqAAAAAGNT9fA4XiIrmukO4MmgkxB09hS1" // Replace with your actual site key
                  onChange={onCaptchaChange}
                />
                {captchaError && (
                  <p className="text-red-500 text-sm mt-2">{captchaError}</p>
                )}
              </div>

              {/* Submit Button */}
              <div className="mt-6 py-1 bg-orange-500 md:w-1/4 w-1/2 hover:bg-orange-400 flex justify-center items-center">
                <button type="submit" className="text-white px-6 rounded-md">
                  Send Message
                </button>
              </div>

              {/* Submission Status */}
              {submissionStatus && (
                <p className={`mt-4 ${submissionStatus.includes("Success") ? "text-green-500" : "text-red-500"}`}>
                  {submissionStatus}
                </p>
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Contact;
